<template>
    <div style="background-color: #f6f6f6;padding-top: 80px;">
    <div class="resume-box">
      <!--2023-4-24-->
      <div class="resume-left">
        <div class="resume-left" v-if="resumeInfo !== ''" style="margin-right: 35px;" id="pdfCentent">
          <div class="resume-left-top-header">
            <div class="resume-left-top-header-txt">
              <img class="resume-left-top-header-txt-img" v-if="resumeInfo.logo===undefined && resumeInfo.sex=== '男'" src="../../assets/boyLogo.png" />
              <img class="resume-left-top-header-txt-img" v-if="resumeInfo.logo===undefined && resumeInfo.sex=== '女'" src="../../assets/girlLogo.png" />
              <img class="resume-left-top-header-txt-img" v-if="resumeInfo.logo!==undefined" :src="resumeInfo.logo"  />
              <div class="resume-left-top-header-txt-info">
                <div class="resume-top-center-txt-name">{{resumeInfo.name}}</div>
                <div class="resume-left-top-header-txt-box">
                  <div class="resume-left-top-txt-one-resumeVue" style="padding-left: 0;">
                    <img src="../../assets/resume-icon7.png" />
                    <div>{{resumeInfo.sex}}</div>
                  </div>
                  <div class="resume-left-top-txt-one-resumeVue">
                    <!-- <img src="../../assets/resume-icon2.png" /> -->
                    <div>年龄：{{ resumeInfo.age }}</div>
                  </div>
                  <div class="resume-left-top-txt-one-resumeVue" style="border-right: none">
                    <!-- <img src="../../assets/resume-icon6.png" /> -->
                    <div>工作经验：{{resumeInfo.work}}</div>
                  </div>
                </div>
                <div class="resume-left-top-header-txt-box">
                  <div class="resume-left-top-txt-one-resumeVue" style="padding-left: 0;">
                    <img src="../../assets/resume-icon3.png" />
                    <div>{{resumeInfo.condition}}</div>
                  </div>
                  <div class="resume-left-top-txt-one-resumeVue" style="border-right: none">
                    <img src="../../assets/resume-icon4.png" />
                    <div>{{phone}}</div>
                    <div v-if="lookLinkPhoneBtn==true" style="color:#597BF6;cursor: pointer;margin-left: 10px;" @click="lookLinkPhoneCompany()">查看</div>
                    <div v-if="lookLinkPhoneBtn==false"></div>
<!--                    <div style="color:#597BF6;cursor: pointer;margin-left: 10px;" @click="query()">查看</div>-->
                  </div>
                </div>
              </div>
            </div>
            <!--下载/收藏简历-->
            <div class="resumeBtns resumeBtns_resumeDetailVue" style="margin-bottom: 10px;margin-top: 10px;margin-right: 31px">
              <button class="resumeSub resumeCheckBtnItem_resumeDetailVue" v-if="isCollection==false" @click="preserve()">收藏</button>
              <button class="resumeSub resumeCheckBtnItem_resumeDetailVue" style="background: #8cc331 !important;color: #fff!important;border: none" v-if="isCollection==true" @click="preserve()">取消收藏</button>
              <el-button type="danger" style="width: 78px;height: 32px;line-height: 32px;border-radius: 5px;border: none;font-size: 16px;padding: 0;background-color:#169bd5;color: #fff" @click="ExportSavePdf(resumeInfo.name,nowTime,resumeInfo.id)">下载</el-button>
            </div>
            <!--下载/收藏简历-->
          </div>
          <div class="resume-modular-resumeVue">
            <div class="resume-modular-box-resumeVue">
              <div class="resume-modular-title-resumeVue">
                <img src="../../assets/index-line.png" />
                <div>求职期望</div>
              </div>
            </div>
            <div class="resume-modular-tabel-resumeVue">
              <div>{{resumeInfo.jobName}}</div>
<!--              <div v-if="resumeInfo.salary!==0&&resumeInfo.salaryEnd!==0">{{resumeInfo.salary}}-{{resumeInfo.salaryEnd}}/月</div>
              <div v-if="resumeInfo.salary==0&&resumeInfo.salaryEnd!==0">{{resumeInfo.salaryEnd}}元以下</div>
              <div v-if="resumeInfo.salaryEnd==0&&resumeInfo.salary!==0">{{resumeInfo.salary}}元以上</div>-->
              <div>{{resumeInfo.salaryName}}</div>
              <div>{{resumeInfo.cityName}}</div>
              <div>{{resumeInfo.type}}</div>
            </div>
          </div>
          <div class="resume-modulars" v-if="resumeInfo.selfIntroduction!=''">
            <div class="resume-modular-box-resumeVue">
              <div class="resume-modular-title-resumeVue">
                <img src="../../assets/index-line.png" />
                <div>自我介绍</div>
              </div>
            </div>
            <div class="resume-modular-introduce">{{resumeInfo.selfIntroduction}}</div>
          </div>
          <div class="resume-modular-resumeVue" v-if="resumeInfo.workList!==undefined&&resumeInfo.workList.length > 0">
            <div class="resume-modular-box-resumeVue">
              <div class="resume-modular-title-resumeVue">
                <img src="../../assets/index-line.png" />
                <div>工作经历</div>
              </div>
            </div>
            <div style="overflow: hidden;" v-for="(items,indexs) in resumeInfo.workList" :key="indexs" >
              <img style="float: left;margin-left: 41px;width: 14px;height: 14px;margin-top: 3px;" src="../../assets/vita-icon.png" alt="">
              <div class="resume-modular-tabel-resumeVue" style="float: left;margin-left: 8px;width: 786px;">
                <div class="resume-modular-tabel-job-resumeVue">
                  <span>{{ items.companyName }}</span>
                  <span style="margin-left: 48px;color: #909090" >{{ items.startTime }}~{{ items.endTime }}</span>
                </div>
                <div class="resume-modular-tabel-job-resumeVue">{{ items.jobInfo }}</div>
                <div class="resume-modular-tabel-job-resumeVue">工作描述：{{items.content}}</div>
              </div>
            </div>
          </div>
          <div class="resume-modular-resumeVue">
            <div class="resume-modular-box-resumeVue">
              <div class="resume-modular-title-resumeVue">
                <img src="../../assets/index-line.png" />
                <div>教育经历</div>
              </div>
            </div>
            <div class="resume-modular-tabel-resumeVue">
              <div>{{resumeInfo.school}}</div>
              <div>{{resumeInfo.edu}}</div>
              <div>{{resumeInfo.major}}</div>
              <div>毕业时间：{{resumeInfo.graduationDate}}</div>
            </div>
          </div>
          <div class="resume-modular-resumeVue" v-if="resumeInfo.certificate!==undefined">
            <div class="resume-modular-box-resumeVue">
              <div class="resume-modular-title-resumeVue">
                <img src="../../assets/index-line.png" />
                <div>资格证书</div>
              </div>
            </div>
            <div class="resume-modular-tabel-resumeVue">
              <div>{{resumeInfo.certificate}}</div>
            </div>
          </div>
        </div>
        <!-- 保存个人简历 -->
<!--        <div class="resumeBtns" style="margin-bottom: 30px;">-->
<!--          <el-button type="danger" style="width: 147px;height: 40px;line-height: 40px;border-radius: 20px;border: none;font-size: 16px;padding: 0;margin-right: 40px;" @click="ExportSavePdf(resumeInfo.name,nowTime,resumeInfo.id)">下载</el-button>-->
<!--          <button class="resumeSub resumeCheckBtnItem" v-if="isCollection==false" @click="preserve()">收藏</button>-->
<!--          <button class="resumeSub resumeCheckBtnItem" v-if="isCollection==true" @click="preserve()">取消收藏</button>-->
<!--        </div>-->
        <!-- 下载简历/收藏简历 -->
      </div>
      <!-- 个人信息 -->
      <div class="personalCore-right">
        <div class="personalCores-right-info">
          <img :src="userInfo.userPhoto" />
          <div class="personalCores-right-info-divs">
            <div class="personalCores-right-info-div-name">{{userInfo.companyName}}</div>
            <div class="personalCores-right-info-div-vip" v-if="userInfo.isCompanyVip==true">企业会员</div>
          </div>
        </div>
        <div class="personalCore-right-box">
          <div class="personalCore-right-boxs" style="margin-left: 32px;" @click="go()">
            <img src="../../assets/Enterprise-icon1.png" />
            <div>职位列表</div>
          </div>
          <div class="personalCore-right-boxs" style="margin-left: 24px;" @click="curriculumVitae()">
            <img src="../../assets/Enterprise-icon2.png" />
            <div>简历管理</div>
          </div>
          <div class="personalCore-right-boxs" style="margin-left: 32px;" @click="goss()">
            <img src="../../assets/Enterprise-icon4.png" />
            <div>企业信息</div>
          </div>
          <div class="personalCore-right-boxs" style="margin-left: 24px;" @click="postRelease()">
            <img src="../../assets/Enterprise-icon3.png" />
            <div>发布职位</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../../util/request'

export default {
  data () {
    return {
      resumeInfo: {},
      userInfo: {},
      id: '',
      isCollection: '',
      isDownload: '',
      htmlTitle: '',
      nowTime: '',
      phone: '',
      logoBase64: '',
      isVip: false,
      lookLinkPhoneBtn: true
    }
  },
  beforeCreate () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  mounted () {
    this.id = this.$route.query.id
  },
  methods: {
    getData () {
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user/resumeDetail`,
        data: JSON.stringify({
          id: that.id
        })
      }).then(
        (res) => {
          that.resumeInfo = res.data.data.resumeInfo
          that.isVip = res.data.data.isVip
          that.phone = that.resumeInfo.phone
          // console.log(that.resumeInfo.logo)
          // if (that.resumeInfo.logo !== undefined) {
          //   let image = new Image()
          //   image.setAttribute('crossOrigin', 'anonymous')
          //   console.log(that.resumeInfo.logo)
          //   let imageUrl = 'https://hzrc.oss-cn-shenzhen.aliyuncs.com/resume/20231228/1535254865d678.png' // that.resumeInfo.logo
          //   image.src = imageUrl
          //   image.onload = () => {
          //     var canvas = document.createElement('canvas')
          //     canvas.width = image.width
          //     canvas.height = image.height
          //     var context = canvas.getContext('2d')
          //     context.drawImage(image, 0, 0, image.width, image.height)
          //     var quality = 0.8
          //     var dataURL = canvas.toDataURL('image/jpeg', quality)
          //     // that.logo = dataURL
          //     // console.log(dataURL, 'dataURL')
          //     that.resumeInfo.logo = dataURL
          //   }
          // }
          that.isCollection = res.data.data.isCollection
          that.isDownload = res.data.data.isDownload
          // 隐藏手机号
          // const phone = that.phone
          // that.phone = phone.substr(0, 3) + '****' + phone.substr(7)
        },
        (err) => {
          that.$message.error(err)
        }
      )
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `/web/user`,
        data: JSON.stringify({})
      }).then(
        (res) => {
          that.userInfo = res.data.data.userInfo
        },
        (err) => {
          that.$message.error(err)
        }
      )
    },
    preserve () {
      var that = this
      if (that.isCollection === false) {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/job/addCollection`,
          data: JSON.stringify({
            id: that.id,
            type: 2,
            operation: 1
          })
        }).then(
          (res) => {
            that.$message.success('收藏成功')
            that.getData()
          },
          (err) => {
            that.$message.error(err)
          }
        )
      } else {
        request({
          method: 'post',
          headers: {
            'Content-Type': 'application/json; charset=utf-8',
            token: '',
            Bearer: localStorage.getItem('token')
          },
          url: `/job/addCollection`,
          data: JSON.stringify({
            id: that.id,
            type: 2,
            operation: 2
          })
        }).then(
          (res) => {
            that.$message.success('取消收藏成功')
            that.getData()
          },
          (err) => {
            that.$message.error(err)
          }
        )
      }
    },
    query () {
      var that = this
      if (that.isVip === false) {
        that.$message.error('请开通企业VIP后查看！')
      } else {
        this.phone = this.resumeInfo.phoneAll
      }
    },
    go () {
      this.$router.push({ path: '/jobLists' })
    },
    postRelease () {
      this.$router.push({ path: '/releaseJob' })
    },
    goss () {
      this.$router.push({ path: '/enterpriseInformation' })
    },
    curriculumVitae () {
      this.$router.push({ path: '/curriculumVitae' })
    },
    lookLinkPhoneCompany () { // 查看联系电话
      var that = this
      request({
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          token: '',
          Bearer: localStorage.getItem('token')
        },
        url: `web/user/resumePhone`,
        data: JSON.stringify({
          id: this.id
        })
      }).then(
        (res) => {
          console.log(res)
          var status = res.data.data.status
          if (status === '1') { // 1是提示完善简历
            // 想要吧内容折行，先把他们拆分为数组
            const confirmText = ['你今天的权益已用完', '请联系客服：0591-28025182']
            const newDates = []
            const h = this.$createElement
            for (const i in confirmText) {
              newDates.push(h('p', null, confirmText[i]))
            }
            that.$confirm('提示', {
              title: '提示',
              message: h('div', null, newDates),
              center: true,
              confirmButtonText: '去完善',
              cancelButtonText: '取消',
              showCancelButton: false,
              showConfirmButton: false,
              type: 'warning'
            }).then(() => { // 点击去完善后跳转页面
              that.$router.push({path: '/editResume'})
            }).catch(() => {})
            return false
          } else { // 其他状态是直接查看简历
            that.phone = res.data.data.phone // 赋值
            that.lookLinkPhoneBtn = false
          }
        },
        (err) => {
          that.$message.error(err)
        }
      )
    }
  }
}

</script>

<style>
.resume-box {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 31px;
}
/* 按钮 */
.resumeBtns {
  text-align: center;
  width: 100%;
  font-size: 16px;
  margin-top: 54px;
}
.resumeBtns_resumeDetailVue{
  float: right;
  width: 78px;
}
.resumeCheckBtnItem_resumeDetailVue {
  width: 78px;
  height: 32px;
  line-height: 32px;
  border-radius: 5px;
  border: 1px solid #797979;
  font-size: 16px;
  margin-bottom: 16px;
  background: #fff !important;
  color: #333 !important;
}

.resumeCancel {
  /*border: 1px solid #B0A7A7;*/
  color: #6D6D6D;
  background: #fff;
  margin-right: 40px;
}

.resumeSub {
  color: #fff;
  /*border: 1px solid #587CF7;*/
  background: #587CF7;

}

.personalCore-right{
  width: 307px;
  float: left;
  height: 407px;
  background-color: #fff;
  border-radius: 10px;
}
.personalCores-right-info{
  overflow: hidden;
  width: 100%;
  height: 122px;
  border-bottom: 1px solid #ECECEC;
}
.personalCores-right-info img{
  float: left;
  width: 75px;
  height: 75px;
  margin-top: 27px;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 37.5px;
}
.personalCores-right-info-divs{
  float: left;
  margin-top: 36px;
  width: 60%;
}
.personalCores-right-info-div-name{
  font-size: 18px;
  margin-bottom: 8px;
}
.personalCores-right-info-div-vip{
  font-size: 12px;
  color: #E7BD7F;
  width: 71px;
  height: 19px;
  line-height: 19px;
  background-color: #373333;
  text-align: center;
  border-top-left-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
}
.personalCore-right-box{
  width: 100%;
}
.personalCore-right-boxs{
  width: 110px;
  height: 110px;
  display: inline-block;
  position: relative;
  margin-left: 44px;
  margin-top: 24px;
  cursor: pointer;
}
.personalCore-right-boxs img{
  width: 100%;
  height: 100%;
}
.personalCore-right-boxs div{
  position: absolute;
  top: 70px;
  left: 19px;
  font-size: 18px;
}
.resumeCancel{
  cursor: pointer;
}
.resumeSub{
  cursor: pointer;
}

.resume-box{
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 31px;
}
.resume-left{
  float: left;
  width: 857px;
  margin-right: 24px;
}
.resume-left-top-header{
  width: 100%;
  background-color: #fff;
  overflow: hidden;
  margin-bottom: 21px;
  padding: 17px 0;
}
.resume-left-top-header-txt{
  float: left;
  overflow: hidden;
}
.resume-left-top-header-txt-img{
  width: 88px;
  height: 88px;
  float: left;
  margin-right: 44px;
  margin-top: 4px;
  margin-left: 31px;
  border-radius: 50%;
}
.resume-left-top-header-txt-info{
  float: left;
  /*margin-top: 17px;*/
}
.resume-top-center-txt-name{
  font-size: 24px;
  height: 33px;
  line-height: 33px;
  font-weight: 550;
}
.resume-left-top-header-txt-box{
  overflow: hidden;
  margin-top: 10px;
}
.resume-left-top-txt-one-resumeVue{
  float: left;
  overflow: hidden;
  /*margin-right: 23px;*/
  padding-right: 11px;
  border-right: 1px solid #979797;
  padding-left: 11px;
}
.resume-left-top-txt-one-resumeVue img{
  width: 16px;
  height: 16px;
  float: left;
  margin-top: 3px;
  margin-right: 4px;
}
.resume-left-top-txt-one-resumeVue div{
  float: left;
  font-size: 14px;
  color: #535353;
  margin-left: 4px ;
}
.resume-left-top-header-txts{
  float: right;
  color: #027FFE;
  font-size: 16px;
  margin-right: 52px;
  margin-top: 6px;
  display: flex;
  align-items: center;
}
.resume-left-top-header-txts img{
  width: 16px;
  height: 16px;
  margin-left: 5px;
}
.resume-modular-resumeVue{
  width: 857px;
  /*height: 107px;*/
  background-color: #fff;
  margin-bottom: 20px;
  padding-bottom: 25px;
}
.resume-modular-box-resumeVue{
  overflow: hidden;
  width: 100%;
  position: relative;
  margin-bottom: 24px;
}
.resume-modular-title-resumeVue{
  float: left;
}
.resume-modular-title-resumeVue img{
  width: 65px;
  height: 5px;
  left: 40px;
  position: absolute;
  top: 0;
}
.resume-modular-title-resumeVue div{
  margin-top: 25px;
  margin-left: 40px;
  font-size: 18px;
  font-weight: 550;
}
.resume-modular-add-resumeVue{
  float: right;
  width: 16px;
  height: 16px;
  margin-right: 53px;
  margin-top: 30px;
}
.resume-modular-tabel-resumeVue{
  margin-left: 41px;
  overflow: hidden;
  line-height: 20px;
}
.deleteWorkList{
  color: #007aff;
  float: right !important;
  padding-right: 0 !important;
  margin-right: 0 !important;
}
.resume-modular-tabel-resumeVue div{
  float: left;
  font-size: 14px;
  padding-right: 20px;
  border-right: 2px solid #979797;
  margin-right: 20px;
}
.resume-modular-tabel-resumeVue div:last-child{
  border-right: none
}
.resume-modular-tabel-job-resumeVue{
  float: none !important;
  margin-bottom: 16px;
  border-right: 0!important;
}
.resume-modulars{
  width: 857px;
  background-color: #fff;
  margin-bottom: 25px;
  padding-bottom: 18px;
}
.resume-modular-titles{
  width: 100%;
  position: relative;
}
.resume-modular-titles img{
  width: 65px;
  height: 5px;
  left: 40px;
  position: absolute;
  top: 5px;
}
.resume-modular-titles div{
  padding-top: 23px;
  margin-left: 41px;
  font-size: 18px;
  font-weight: 550;
}
.resume-modular-introduce{
  width: 758px;
  padding: 12px 16px;
  margin: 0 auto;
  border: 1px solid #ECECEC;
  border-radius: 5px;
  margin-top: 19px;
}
.resume-menus{
  float: left;
  width: 297px;
  height: 368px;
  background-color: #fff;
}
.resume-menus div{
  width: 269px;
  height: 60.4px;
  line-height: 60.4px;
  padding-left: 28px;
}
</style>



// WEBPACK FOOTER //
// src/views/enterprise/resumeDetail.vue